<template>
  <div class="home" id="view">
    <hero-section />
    <helped-section />

    <aim-section />

    <stories-section />
    <!-- <carousel-section /> -->
    <derisk-section />

    <news-letter />
  </div>
</template>

<script>
// Global Components

// Local Components
import AimSectionVue from './Sections/AimSection.vue';
import DeRiskCTA from './Sections/DeRiskCTA.vue';
// import CarouselSectionVue from './Sections/CarouselSection.vue';
import HeroSectionVue from './Sections/HeroSection.vue';
// import NewsLetterVue from './Sections/NewsLetter.vue';
import StoriesSection from './Sections/StoriesSection.vue';
import Newsletter from '../resources/partials/Newsletter.vue';
import WhoWeHelped from './Sections/WhoWeHelped.vue';

export default {
  name: 'HomeIndex',
  components: {
    'hero-section': HeroSectionVue,
    'helped-section': WhoWeHelped,
    'aim-section': AimSectionVue,
    // 'carousel-section': CarouselSectionVue,
    'stories-section': StoriesSection,
    'news-letter': Newsletter,
    'derisk-section': DeRiskCTA,
  },
  created() {
    document.getElementById('loaderSection').classList.add('d-none');
  },
};
</script>

<style scoped>
.home {
  width: 100vw;
  overflow-x: hidden;
}
</style>
